import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const emojiClassName = css({
  display: 'flex',
  position: 'relative',
  zIndex: 99,
  '& .EmojiPickerReact': {
    '--epr-emoji-size': '26px',
    '--epr-header-padding': '8px var(--epr-horizontal-padding)',
    '--epr-search-input-bg-color-active': 'var(--epr-search-input-bg-color)',
    '--epr-search-border-color': 'var(--epr-search-input-bg-color)',
    '--epr-category-navigation-button-size': '26px',
    '--epr-category-label-height': '28px',
    fontSize: FontSize.REGULAR,
  },
  '& .epr-emoji-category-label': {
    fontSize: FontSize.REGULAR,
  },
});

export const actionClassName = css({
  position: 'absolute',
  right: Spacing.MD,
  bottom: `calc(50% - (18px / 2))`,
});

export const buttonClassName = css({
  color: Colors.Secondary,
  padding: 0,
});

export const iconClassName = css({
  height: 18,
  width: 18,
});

export const menuClassName = css({
  bottom: 0,
  marginRight: Spacing['2XS'],
  position: 'absolute',
  right: 18,
});
